import { combineReducers } from 'redux';

import { AppStateStoreAction, GlobalAppState } from 'interfaces/store';

import calculatorReducer from './calculator';

const AppState: GlobalAppState = {};

const appReducer = (
// eslint-disable-next-line @typescript-eslint/default-param-last
  state:GlobalAppState = AppState,
  action: AppStateStoreAction,
) => {
  const { type: actionType } = action;
  switch (actionType) {
    default:
      return state;
  }
};

const rootReducer = combineReducers({
  app: appReducer,
  calculator: calculatorReducer,
});

export default rootReducer;
